export default __webpack_public_path__ + "40135ca27a5a5461aaecb4ac19c70a80.svg";